import { graphql } from "@/gql";

export const createBookingChangeRequestMutation = graphql(`
  mutation CreateBookingChangeRequest(
    $bookingUuid: String!
    $input: CreateBookingChangeRequestInput
  ) {
    createBookingChangeRequest(bookingUuid: $bookingUuid, input: $input) {
      id
      uuid
      amount
      currency
      price_delta_amount
      admin_fee_amount
    }
  }
`);

export const sendBookingChangeRequestPaymentRequestMutation = graphql(`
  mutation SendBookingChangeRequestPaymentRequest($id: ID!) {
    sendBookingChangeRequestPaymentRequest(id: $id) {
      id
      status
    }
  }
`);

export const resolveChangeRequestMutation = graphql(`
  mutation ResolveBookingChangeRequestMutation(
    $id: ID!
    $input: ResolveBookingChangeRequestInput!
  ) {
    resolveBookingChangeRequest(id: $id, input: $input) {
      id
    }
  }
`);
